import { render, staticRenderFns } from "./qa1.vue?vue&type=template&id=95734662&"
import script from "./qa1.vue?vue&type=script&lang=js&"
export * from "./qa1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95734662')) {
      api.createRecord('95734662', component.options)
    } else {
      api.reload('95734662', component.options)
    }
    module.hot.accept("./qa1.vue?vue&type=template&id=95734662&", function () {
      api.rerender('95734662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/qa1.vue"
export default component.exports